import ListingsRoutingResolver from './ListingRoutingResolver';

class AccountingBankListingRoutingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "accounting-bank"
    }
}

export default AccountingBankListingRoutingResolver
